import Hero from '../components/Hero';
import Brands from '../components/Brands';
import Purpose from '../components/Purpose';
import Journey from '../components/Journey';
import Founder from '../components/Founder';

export default function Home() {
  return (
    <>
      <Hero />
      <Brands />
      <Purpose />
      <Journey />
      <Founder />
    </>
  );
}
